// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errormessage[data-v-5eb2dd33]{font-size:12px;font-weight:500;line-height:1.5;color:var(--red900)}.errormessage.notext[data-v-5eb2dd33]{color:transparent}", ""]);
// Exports
module.exports = exports;
